import { render, staticRenderFns } from "./CRUDUnidades.vue?vue&type=template&id=55b708b9&scoped=true&"
import script from "./CRUDUnidades.vue?vue&type=script&lang=js&"
export * from "./CRUDUnidades.vue?vue&type=script&lang=js&"
import style0 from "./CRUDUnidades.vue?vue&type=style&index=0&id=55b708b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b708b9",
  null
  
)

export default component.exports